import React, { useEffect, useState } from "react";
import $ from "jquery";
import axios from "axios"; 
import FormValidator from "../../../inc/FormValidator";
import Api from "../../../inc/Api";
import Settings from "../../../inc/Settings";
import Button from "../../inc/Button";
import Collapse from "../../inc/Collapse"; 
import FieldsRenderer from "../../Purchase Orders Internal/Edit PO/FieldsRenderer";
import Helper from "../../../inc/Helper";
import { Form } from "react-bootstrap";
import { getPopupMessageBasedOnStatus } from "../../../inc/Validation";
import Popup from "../../Popup/Popup";
import MasterComponentWraper from "../../Backend/MasterComponentWraper";
import CommonAPICalls from "../Common Integration Calls/CommonApiCalls";

let cancelTokenSource = axios.CancelToken.source();
const CredentialStoreFormsPopup = ({ setClosePopupViewModal, reloadParentGrid }) => { 
  const [popupFormData, setPopupFormData] = useState({});
  const [appMaster, setAppMaster] = useState([]);
 
  const [apiCallBtn, setApiCallBtn] = useState(false);

  useEffect(() => {  
    fetchDataForAppMaster();
  }, [])

  let popupFormValidator;

  const validationConfigure = () => {
    let popupFieldConfig = [ 
      { name: "login_id", displayName: "User email", types: ["Required", "Email"] },
      { name: "login_password", displayName: "Password", types: ["Required"] }, 
      { name: "api_master", displayName: "App", types: ["Required"] }, 
      // { name: "token", displayName: "Token", types: ["Required"] },
    ];

    if (!popupFormValidator) {
      popupFormValidator = new FormValidator(popupFieldConfig);
    }
  };

  validationConfigure();

  const fetchDataForAppMaster = async () => {
    const apiCalls = new CommonAPICalls();
    try {
      const systemAppMasterResponse = await apiCalls.getSystemApiDetails();
      if (systemAppMasterResponse) {
        setAppMaster(systemAppMasterResponse);
      };
    } catch (error) { 
      setAppMaster([]); 
    }
  }
  
  const fieldsArrayGeneral = [ 
    {
      className: "col-lg-4",
      label: "User email",
      inputType: "text",
      required: true,
      id: "login_id",
      name: "login_id",
    },
    {
      className: "col-lg-4",
      label: "Password",
      inputType: "password_eye",
      required: true,
      id: "login_password",
      name: "login_password",
    },  
    {
      className: "col-lg-4",
      label: "App",
      inputType: "dropdown",
      options: appMaster,
      required: true,
      id: "api_master",
      name: "api_master",
    },
    // {
    //   className: "col-lg-4",
    //   label: "Token",
    //   inputType: "text",
    //   id: "token",
    //   required: true,
    //   name: "token",
    // } 
  ];

  const onClosePopupClick = () => {
    $("html").removeClass("rs_popup_open");
    setClosePopupViewModal(false);
  };

  const executePOSTPopupDocumentAPI = async () => {
    try { 
      let api = Api;
      api.setUserToken();

      const res = await api
        .axios()
        .post(
          Settings.apiAppUrl + "/credentials/",
          popupFormData,
          { cancelToken: cancelTokenSource.token }
        );

      if (res?.data?.success) {
        Helper.alert(res?.data?.message || 'Credentials store created successfully', 'success');
        reloadParentGrid();
        onClosePopupClick(); 
      } else {
        Helper.alert(res?.data?.message, 'error')
      }
    } catch (error) {
      getPopupMessageBasedOnStatus(error);
    }
  };

  const handleSubmit = () => {
    if (!popupFormValidator.isValid({ ...popupFormData })) {
      popupFormValidator.displayMessage();
      popupFormValidator.reset();
      return;
    }

    Helper.createDebouncedAPIFunction(
      [executePOSTPopupDocumentAPI],
      setApiCallBtn,
      cancelTokenSource
    )();
  };
  return (
    <Popup
      autoOpen={true}
      width="900px"
      onClose={onClosePopupClick}
    > 
      <>
        <h5 className="create_rfq_modal__title">Create Credential Store</h5>

        <Collapse
          className="mt-4 mb-4"
          open={true}
          title={"General Information"}
        >
          <Form>
            <div className="container-fluid">
              <FieldsRenderer
                updateState={setPopupFormData}
                currentState={popupFormData}
                fieldsArray={fieldsArrayGeneral}
              />
            </div>
          </Form>
        </Collapse>
      </> 

      <div
        className="addDocumentNumber-body-buttons"
        style={{ justifyContent: "flex-end" }}
      >
        <Button
          isActive={false}
          title={"Cancel"}
          onClick={onClosePopupClick}
        />
        <Button
          isDisable={apiCallBtn}
          className="solid_btn"
          isActive={true}
          title={<div><span> {"Create"} </span> {apiCallBtn ? <output className="spinner-border spinner-border-sm ms-1" aria-hidden="true"></output> : ''}</div>}
          onClick={handleSubmit}
        />
      </div>
    </Popup>
  );
};

export default (MasterComponentWraper(CredentialStoreFormsPopup));